const booking = {
  bookingInformation: "ข้อมูลการจอง", // translated
  ourCancellationPolicy: "นโยบายการยกเลิกของเรา", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "สิ่งนี้จะมีผลแทนนโยบายการยกเลิกใดๆ ในหมายเหตุข้างต้น", // translated
  thisBookingIsNonNefundable: "การจองนี้ไม่สามารถคืนเงินได้", // translated
  paymentTerms: "เงื่อนไขการชำระเงิน", // translated
  paymentWillBeTakenFromYourDefault: "การชำระเงินจะถูกหักออกจากค่าเริ่มต้นของคุณ", // translated
  paymentMethod: "วิธีการชำระเงิน", // translated
  afterTheFreeCancellationPeriodIfApplicable: "หลังจากระยะเวลาการยกเลิกฟรี ถ้ามี", // translated
  prebook: "จองล่วงหน้า", // translated
  guests: "แขก", // translated
  payment: "การชำระเงิน", // translated
  byClicking: "โดยคลิก", // translated
  youAreAgreeingToOur: "คุณเห็นด้วยกับเรา", // translated
  termsAndConditions: "ข้อกำหนดและเงื่อนไข", // translated
  lastBookableDate: "วันที่จองได้ครั้งสุดท้าย", // translated
  customerRemarksTextfield: "หมายเหตุของลูกค้า", // translated
  request: "ขอ", // translated
  cancellationPolicy: "นโยบายการยกเลิก", // translated
};

export default booking;
